import { API } from '../../hooks/apiHook';

export const getUserActivitySummaryApi = (userId) =>
  API.get('/user-activity-summary/', {
    params: {
      user_id: userId,
    },
  });
